import React, { useEffect } from "react";
import Navigationtitle from "../include/Navigationtitle";
import { Link } from "react-router-dom";
import * as AiIcons from "react-icons/ai";
import { Image, Shimmer } from "react-shimmer";
import { useSelector } from "react-redux";
import { playerdefaultLogo } from "../../constants/Images";

function Profile(match) {
  const getpageData = useSelector((state) => state.setUserlog);
   console.log(getpageData, "getpageData");
  const replaceImage = (error) => {
    //  console.log('broken...');
    //  console.log(playerdefaultLogo);
      //replacement of broken Image
      error.target.src = playerdefaultLogo;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <section className="event-area">
              <div className="container-fluid">
                <div>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="card-auction-detail text-align-center width-110per">
                        <Image
                          className="img-width"
                          fallback={<Shimmer width={265} height={265} />}
                          src={
                           ( getpageData.photo != null &&
                            getpageData.photo != undefined && getpageData.photo !="")
                              ? getpageData.photo
                              : playerdefaultLogo
                          }
                          onError={replaceImage}
                        ></Image>
                      </div>
                    </div>

                    <div className="col-md-9">
                      <div className="card-auction-detail my-profile-detail width-110per">
                        <div className="row">
                          <div className="col-md-3 col-xs-4">
                            <h4>Name </h4>
                          </div>
                          <div className="col-md-6 col-xs-8">
                            {" "}
                            : {getpageData.cperson}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3 col-xs-4">
                            <h4>Mobile No</h4>
                          </div>
                          <div className="col-md-6 col-xs-8">
                            {" "}
                            : {getpageData.mobno}
                          </div>
                        </div>

                        {/* <div className="row">
                          <div className="col-md-2 col-xs-4">
                            <h4>Dob</h4>
                          </div>
                          <div className="col-md-6 col-xs-8">
                            {" "}
                            : {getpageData.dob}
                          </div>
                        </div> */}

                        <div className="row">
                          <div className="col-md-3 col-xs-4">
                            <h4>Email Id</h4>
                          </div>
                          <div className="col-md-6 col-xs-8">
                            : {getpageData.emailid}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3 col-xs-4">
                            <h4>City</h4>
                          </div>
                          <div className="col-md-6 col-xs-8">
                            : {getpageData.city}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="card-auction-detail auc-dt-left width-110per">
                        <ul>
                          <li className="">
                            <Link to="/edit-profile">
                              <AiIcons.AiOutlineTeam /> Edit Profile
                            </Link>
                          </li>

                          <li>
                            <Link to="/change-password">
                              <AiIcons.AiOutlineUser /> Change Password
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
export default Profile;
